import { get, head } from "lodash-es";

import { REGISTER_MESSAGE_CODE_TO_GTM_ERROR_MESSAGE, TelemetryErrorPayload } from "./registration-telemetry.model";

export function getErrorMessage(error: TelemetryErrorPayload): string {
	const errorMessage =
		head(error.reasons) || // status error
		(head<{ code: string }>(get(error, "data.errors")) || { code: undefined }).code || // validation error
		error.code ||
		"generic";

	return REGISTER_MESSAGE_CODE_TO_GTM_ERROR_MESSAGE[errorMessage] ?? errorMessage;
}
